// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1WmWd","row":"ProcedureTreatmentSummary_row__3p76l"};